<script setup lang="ts">
import ReferenceTitle from '@/components/references/ReferenceTitle.vue'

interface Props {
  /** The reference item to display */
  item: ReferenceInterface
}

defineProps<Props>()

defineOptions({
  name: 'ReferenceDatatableRow'
})
</script>

<template>
  <td class="pl-4!">
    <div class="flex flex-col gap-y-0.5">
      <ReferenceTitle :title="item.title" />
    </div>
  </td>
  <td>
    <slot name="date" :date="item.date" />
  </td>
  <td>
    <slot name="status" :status="item.status" />
  </td>
  <td>
    <slot name="badge" :item>
      {{ item.status }} : {{ item.amount?.amount }}
    </slot>
  </td>
  <td class="pr-5!">
    <div class="flex flex-row justify-end">
      <slot name="actions" :actions="item.actions" />
    </div>
  </td>
</template>
